import {IBrandDetail, IBrandFilter, IBrandGroupRow} from './types';


const isEmptyValue = (value?: number | string) => {
    return value === undefined || value === null || value === '';
};

/**
 * 判斷品牌在目前的條件下是否還有商品
 *
 * @param brand 品牌
 * @param filter 目前已選的其他條件 (群組 + 季節 + 特性)
 */
export const isMatchBrand = (brand: IBrandDetail, filter: IBrandFilter): boolean => {
    const {selectedGroupId, selectedSeasonYearId, selectedFeatures = []} = filter;

    const categoryGroupIds = brand.categoryGroupIds ?? [];
    const seasonYearIds = brand.seasonYearIds ?? [];
    const features = brand.features ?? [];

    if (!isEmptyValue(selectedGroupId) && !categoryGroupIds.some(id => String(id) === String(selectedGroupId))) {
        return false;
    }

    if (!isEmptyValue(selectedSeasonYearId) && !seasonYearIds.some(id => String(id) === String(selectedSeasonYearId))) {
        return false;
    }

    return selectedFeatures.every(feature => features.includes(feature));
};

/**
 * 依條件過濾品牌清單, 過濾後沒有品牌的首字母分組不回傳
 *
 * @param brandGroup 品牌首字母分組清單
 * @param filter 目前已選的其他條件
 */
export const filterBrandGroup = (brandGroup: IBrandGroupRow[] = [], filter: IBrandFilter): IBrandGroupRow[] => {
    return brandGroup
        .map(row => ({
            ...row,
            detail: (row.detail ?? []).filter(brand => isMatchBrand(brand, filter)),
        }))
        .filter(row => row.detail.length > 0);
};

/**
 * 取得在目前條件下仍有商品的品牌 id
 *
 * @param brandGroup 品牌首字母分組清單
 * @param filter 目前已選的其他條件
 */
export const getMatchBrandIds = (brandGroup: IBrandGroupRow[] = [], filter: IBrandFilter): number[] => {
    return filterBrandGroup(brandGroup, filter)
        .reduce((ids: number[], row) => ids.concat(row.detail.map(brand => brand.id)), []);
};

/**
 * 特性下拉的 code 對應到品牌資料的 features key
 * (code 對應 getPopularOptions, key 與商品列表 API 的 query 參數同名)
 */
const popularFeatureMap: {[key: string]: string} = {
    0: 'isHot',
    1: 'isInStock',
    2: 'isNew',
    3: 'isSale',
    4: 'isVipGoods',
    5: 'isOrderPreSale',
    6: 'isTodaySale',
    7: 'isTodayNew',
};

/**
 * 取得已選特性的 features key 陣列 (未選為空陣列)
 *
 * @param popularId 特性下拉選取的 code
 */
export const getSelectedFeatures = (popularId?: number | string): string[] => {
    if (popularId === undefined || popularId === null || popularId === '') {
        return [];
    }

    const feature = popularFeatureMap[String(popularId)];
    return feature ? [feature] : [];
};
